module.exports = __webpack_public_path__ + "static/media/installing-nodejs-on-your-device.c1670556.md";